import{createContext as t,useContext as e}from"react";var a=t({isMobile:!1}),r=()=>e(a);export{a as FilterVariantContext,r as useFilterVariant};
//# sourceMappingURL=useFilterVariant.js.map